const actionTypes = {
    addUser: 'ADD_USER',
    activateModal: 'ACTIVATE_MODAL',
    deactivateModal: 'DEACTIVATE_MODAL',
    loggedIn: 'USER_LOGGED_IN',
    loggedOut: 'USER_LOGGED_OUT',
    activateBackdrop: 'ACTIVATE_BACKDROP',
    deactivateBackdrop: 'DEACTIVATE_BACKDROP',
    activateSpinner: 'ACTIVATE_SPINNER',
    deactivateSpinner: 'DEACTIVATE_SPINNER',
    activateNav: 'ACTIVATE_NAV',
    deactivateNav: 'DEACTIVATE_NAV'
}


export default actionTypes;
